module.exports = __webpack_public_path__ + "static/media/izmeritelnye_preobrazovateli_ov.32cc6476.pdf";